<template>
    <div class="container-fluid">
        <div class="row justify-content-center">
            <div class="default-page-width">
                <div class="card card-default">
                    <div class="card-header">{{ $t('objects.details.title') }} - {{rmsobject.name}}</div>
                    <div class="card-body">
                        <!-- Due services banner -->
                        <div v-if="duePlanNames && duePlanNames.length" class="alert alert-warning d-flex justify-content-between align-items-center">
                            <div>
                                <strong>{{ $t('objects.details.currently-due') }}:</strong>
                                {{ duePlanNames.join(', ') }}
                            </div>
                        </div>
                        <div v-else class="alert alert-secondary" role="alert">
                            {{ $t('objects.details.none-due') }}
                        </div>
                        <kendo-tabstrip :selected="selected" @select="onSelect" :tabs="tabs">

                            <template v-slot:details>
                                <rms-objects-detail-tab :rmsobject='rmsobject' style="min-width:1400px"></rms-objects-detail-tab>
                            </template>

                            <!--
                            <template v-slot:details>
                                <rms-objects-service-tab :rmsobject='rmsobject'></rms-objects-service-tab>
                            </template>
                            -->

                            <template v-slot:history>
                                <rms-objects-history-tab :rmsobjectid='rmsobjectid' style="min-width:1400px"></rms-objects-history-tab>
                            </template>

                            <template v-slot:orders>
                                <rms-objects-orders-tab :rmsobjectid='rmsobjectid' style="min-width:1400px"></rms-objects-orders-tab>
                            </template>

                            <template v-slot:service>
                                <rms-objects-service-tab :rmsobjectid='rmsobjectid' style="min-width:1400px"></rms-objects-service-tab>
                            </template>

                            <template v-slot:plans>
                                <rms-objects-plans-tab :rmsobject='rmsobject' @reload="init" style="min-width:1400px"></rms-objects-plans-tab>
                            </template>

                        </kendo-tabstrip>
                    </div>
            </div>
            <div class="form-group row h-auto pb-5">
            <div class="col-md-6 offset-md-6">
                <button type="submit" class="btn btn-secondary"
                        @click.prevent="handleBack('objects-grid', true, {reload: false, id: rmsobjectid})">
                    {{ $t('buttons.back') }}
                </button>
                <button type="submit" class="btn btn-primary"
                        v-shortkey.once="['e']" @shortkey="editAction"
                        @click.prevent="editAction">
                    {{ $t('buttons.edit') }}
                </button>
                <button type="submit" class="btn btn-danger"
                        @click.prevent="deleteAction">
                    {{ $t('buttons.delete') }}
                </button>

            </div>
        </div>
    </div>
        </div>
    </div>
</template>

<script>
    import RmsObjectsDetailTab from "./rms-objects-detail-tab";
    import RmsObjectsServiceTab from "./rms-objects-service-tab";
    import RmsObjectsHistoryTab from "./rms-objects-history-tab";
    import RmsObjectsOrdersTab from "./rms-objects-orders-tab";
    import RmsObjectsPlansTab from "./rms-objects-plans-tab";
    export default {
        name: "rms-objects-detail",
        components: {RmsObjectsHistoryTab, RmsObjectsServiceTab, RmsObjectsDetailTab, RmsObjectsOrdersTab, RmsObjectsPlansTab},
        props: ['user', 'rmsobjectid'],
        computed: {
            duePlanNames(){
                return (this.rmsobject && this.rmsobject.due_plan_names) ? this.rmsobject.due_plan_names : [];
            },
            nextDueAssignmentId(){
                return this.rmsobject && this.rmsobject.next_due_assignment_id ? this.rmsobject.next_due_assignment_id : null;
            },
            nextDueOrderId(){
                if(!this.nextDueAssignmentId || !this.rmsobject.service_plans) return null;
                const ap = this.rmsobject.service_plans.find(x => x.assignment_id === this.nextDueAssignmentId);
                return ap ? ap.service_order_id : null;
            },
            canManageServicePlans(){
                return typeof AshnetApp !== 'undefined' && AshnetApp.can && AshnetApp.can('serviceplan manage');
            }
        },
        data: function () {
            return {
                rmsobject: {},
                selected: 0,
                tabs: [
                    {
                        title: this.$t('objects.details.details'),
                        content: 'details',
                    },
                    {
                        title: this.$t('objects.details.change-protocol'),
                        content: 'history',
                    },
                    {
                        title: this.$t('objects.details.orders'),
                        content: 'orders',
                    }
                    // Service-Tab wird hier (siehe mounted()) dynamisch je nach Berechtigung hinzugefügt
                ],
            }
        },
        mounted() {
            this.init();
        },

        methods: {
            init: function () {
                // Prevent duplicate tabs if init is called multiple times
                this.tabs = [
                    {
                        title: this.$t('objects.details.details'),
                        content: 'details',
                    },
                    {
                        title: this.$t('objects.details.change-protocol'),
                        content: 'history',
                    },
                    {
                        title: this.$t('objects.details.orders'),
                        content: 'orders',
                    }
                ];

                if (AshnetApp.can('serviceorder read')) {
                    this.tabs.push({
                        title: this.$t('objects.details.service-orders'),
                        content: 'service',
                    });
                }

                if (typeof AshnetApp !== 'undefined' && AshnetApp.ASH_SERVICE_PLANS_ENABLED) {
                    this.tabs.push({
                        title: this.$t('objects.details.service-plans.title') || 'Servicepläne',
                        content: 'plans',
                    });
                }

                // Laden eines RMS-Objektes
                if (this.rmsobjectid) {
                    axios
                        .get('/api/rmsobjects/id/' + this.rmsobjectid)
                        .then(response => {
                            this.rmsobject = response.data;
                            console.log(this.rmsobject);
                        })
                        .catch(error => {
                            console.log("err", error);
                        })
                        .finally(() => {
                        })
                }

            },
            onSelect: function (e) {
                this.selected = e.selected;
            },
            viewOrder(id) {
                this.$router.push({ name: 'service-order-display', params: { orderid: id } });
            },
            editAction: function () {
                console.log("edit action", this.rmsobjectid);
                const rmsobjectid = this.rmsobjectid;
                this.$router.push({ name: 'objects-edit', params: { rmsobjectid } })
            },
            deleteAction: function () {
                console.log("delete action", this.rmsobjectid);
                swal.fire({
                    title: this.$t('objects.grid.delete-popup-title'),
                    text: this.$t('objects.grid.delete-popup-text'),
                    icon: "warning",
                    showCancelButton: true,
                    cancelButtonText: this.$t('general.cancel'),
                    confirmButtonText: this.$t('general.ok'),
                }).then((willDelete) => {
                    if (willDelete.value) {
                        axios.delete('/api/rmsobjects/delete/' + this.rmsobjectid)
                            .then(response => {
                                console.log("rmsobjects/delete response", response);
                                swal.fire({
                                    text: this.$t('objects.grid.delete-popup-deleted'),
                                    icon: "success",
                                    timer: 2000
                                }).then(response =>{
                                    this.handleBack('objects-grid', true, {reload: true})
                                });
                            });
                    } else {
                        return;
                    }
                });
            }
        }
    }
</script>

<style scoped>

</style>
